import { observer } from 'mobx-react';
import * as React from 'react';
import brandLoaderSvg from '../../assets/brand-loader/execonline-logo-loader.svg';
import { T } from '../../Translations';

// Full-screen loader for app boot. index.html shows the same loader before the
// bundle loads, so keep the two in step.
const BrandLoader: React.FC = () => (
  <div
    className="fixed inset-0 flex items-center justify-center bg-card"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <img src={brandLoaderSvg} alt="" className="h-auto w-[300px] max-w-[80vw]" />
    <span className="sr-only">
      <T kind="loading content" />
    </span>
  </div>
);

export default observer(BrandLoader);
